export default "__VITE_ASSET__c42H0UJz__"